import styled from "styled-components";
import workshop from "../assets/IMG-20250831-WA0004.jpg";
import afterSchool from "../assets/IMG-20250216-WA0020.jpg";
import afterSchoolOut from "../assets/IMG-20250720-WA0005.jpg";
import holiday from "../assets/about.jpg";

const DeliveryModel = () => {
  return (
    <>
      <ModelStyle>
        <h1>Our Delivery Models</h1>
        <ModelContainer>
          <ModelBox>
            <h3>
              Afterschool <br />
              clubs (In-school)
            </h3>
            <img src={afterSchool} alt="" />
            <p>
              We offer Robotics, STEAM, and Coding club programs as after school
              activities within school premises
            </p>
          </ModelBox>
          <ModelBox>
            <h3>
              Afterschool clubs <br /> (Out-of-school)
            </h3>
            <img src={afterSchoolOut} alt="" />
            <p>
              We offer Robotics programs for all levels as an afterschool club
              at the community center in Shinfield
            </p>
          </ModelBox>
          <ModelBox>
            <h3>holiday camps</h3>
            <img src={holiday} alt="" />
            <p>
              We offer Robotics and STEAM programs during Half-Term breaks as
              well as Summer Holidays at the community Centre in Shinfield
            </p>
          </ModelBox>
          <ModelBox>
            <h3>workshops & fayres</h3>
            <img src={workshop} alt="" />
            <p>
              We provide training and workshops for Children as well as Teachers
              on Robotics, and also exhibitions, showcases and experiences at
              Fayres
            </p>
          </ModelBox>
        </ModelContainer>
        <a href="https://techforkids.classforkids.io/" >
          UPCOMING PROGRAMS
        </a>
      </ModelStyle>
    </>
  );
};

const ModelStyle = styled.div`
  margin: 50px 0;
  height: 1000px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.color.azure};

  h1 {
    text-align: center;
    color: #fff;
    padding: 40px 0;
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
     width: 80%;
    }
  }
  a {
    text-align: center;
    position: absolute;
    bottom: -30px;
    padding: 20px 40px;
    font-size: 1.3rem;
    color: #fff;
    text-transform: uppercase;
    text-decoration: none;
    background-color: ${({ theme }) => theme.color.orange};
    width: 500px;
    border-radius: 30px;

    &:hover {
      transform: scale(1.1);
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 80%;
      font-size: 1rem;
    }
  }
   @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      height: 1600px;
    }
`;

const ModelContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 80%;
  height: 700px;
  margin-bottom: 40px;
  gap: 30px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 50%;
    width: 2px;
    height: 100%;
    background-color: #fff;

     @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      display: none;
    }
  }
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    height: 2px;
    width: 100%;
    background-color: #fff;
     @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      display: none;
    }
  }
   @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      grid-template-columns: 1fr;
      height: 1350px;
      width: 100%;
      gap: 0;
    }
`;

const ModelBox = styled.div`
  width: 350px;
  height: 300px;
  overflow: hidden;
  text-align: left;
  margin: 20px auto;
  background-color: ${({ theme }) => theme.color.LightOrange};
  border-radius: 20px;
  padding: 20px;

  h3 {
    font-family: "Orbitron", sans-serif;
    border-bottom: 2px solid #000;
    text-transform: uppercase;
    font-size: 0.9rem;
    padding-bottom: 20px;
    letter-spacing: 3px;;
  }

  img {
    height: 100px;
    width: 100%;
    border-radius: 20px;
    object-fit: cover;
    margin: 25px 0;
  }
  p {
    font-family: "Montserrat", sans-serif;
    font-size: 0.8rem;
  }

   @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: 90%;
    }
`;

export default DeliveryModel;
